import script from "./DefaultProfile.vue?vue&type=script&lang=ts&setup=true"
export * from "./DefaultProfile.vue?vue&type=script&lang=ts&setup=true"

import "./DefaultProfile.vue?vue&type=style&index=0&id=542d53ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-542d53ec"]])

export default __exports__